// ---------------------------------------------------------------
// useTheme.js — Modo oscuro adaptativo (sistema) + switch manual.
// El valor elegido se persiste en localStorage.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";

function systemPrefersDark() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || (systemPrefersDark() ? "dark" : "light");
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Si el usuario no ha elegido manualmente, seguimos al sistema
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e) => {
      if (!localStorage.getItem("theme-manual")) {
        setTheme(e.matches ? "dark" : "light");
      }
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const toggleTheme = () => {
    localStorage.setItem("theme-manual", "1");
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  };

  return [theme, toggleTheme];
}
